import { userApiClient } from '@/setup/api'

export function usePostBecomeAPartner() {
    return userApiClient.useMutation('post', '/web/become-a-partner')
}
